var _rect, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgBackToMyPicks = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_81_1",
    "data-name": "Component 81 \\u2013 1",
    width: 140,
    height: 24,
    viewBox: "0 0 140 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1266",
    "data-name": "Rectangle 1266",
    width: 140,
    height: 24,
    rx: 12,
    fill: "#4b4b4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_51_44",
    "data-name": "Component 51 \\u2013 44",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "BACK_TO_MY_PICKS",
    "data-name": "BACK TO MY PICKS",
    transform: "translate(0 9)",
    fill: "#ececec",
    fontSize: 10,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BACK TO MY PICKS")))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackToMyPicks, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BackToMyPicks.5eb3f3d4.svg";
export { ForwardRef as ReactComponent };